var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance-appraisal-detail"},[(_vm.version == 1)?_c('version-old'):(_vm.version == 2 && _vm.baValue == 2)?_c('version-operation'):(_vm.version == 2 && _vm.baValue == 3)?_c('version-marketing'):(_vm.version == 2 && _vm.baValue == 4)?_c('version-achievement'):_c('version-old')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }